import React from 'react'

import {
  useEditingMixFeed,
  useEditingMixState,
} from '../../../firebase/hooks/useMixes'

import { MixSlotAssignMenu } from './MixSlotAssignMenu'
import { MixSlotPositionMenu } from './MixSlotPositionMenu'

import './MixSlotMenu.scss'

const MixSlotMenu = () => {
  const mix = useEditingMixState()
  const { idx: feedIdx, mode } = useEditingMixFeed()
  const feed = feedIdx !== null ? mix?.feeds[feedIdx] : undefined
  if (!feed) return null

  if (feed.media && mode !== 'swap') return <MixSlotPositionMenu />

  return <MixSlotAssignMenu />
}

export { MixSlotMenu }
